import { render, staticRenderFns } from "./SeniorMembersList.vue?vue&type=template&id=15aceacf&scoped=true"
import script from "./SeniorMembersList.vue?vue&type=script&lang=js"
export * from "./SeniorMembersList.vue?vue&type=script&lang=js"
import style0 from "./SeniorMembersList.vue?vue&type=style&index=0&id=15aceacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aceacf",
  null
  
)

export default component.exports